import React, { useState } from 'react';
import './App.scss';
import routes from '@src/routes';
import { unstable_HistoryRouter as HistoryRouter, Route, Routes } from 'react-router-dom';
import history from '@src/routes/history';
import Toast from '@src/container/common/Toast.js';
import { ToastContext } from '@src/context';

const isDoc = window.location.pathname.includes('Doc');

if (isDoc) {
    import('./AppDoc.scss');
}

function App() {
    const [toastText, setToastText] = useState(null);
    const handleSetToast = (text, closeTime = 1500) => {
        setToastText(text);
        setTimeout(() => {
            setToastText(null);
        }, closeTime);
    };

    return (
        <div className="App">
            <ToastContext.Provider
                value={{
                    setToast: handleSetToast,
                }}
            >
                {toastText && <Toast text={toastText} />}
                <HistoryRouter history={history}>
                    <Routes>{routes.map(renderRoute)}</Routes>
                </HistoryRouter>
            </ToastContext.Provider>
        </div>
    );
}

const renderRoute = (route) => {
    const { name, path, element } = route;

    return <Route key={name} path={path} element={element} />;
};

export default App;
